export const countBadgeSx = {
  px: 0.75,
  borderRadius: '9999px',
  backgroundColor: 'text.link',
  color: 'common.white',
  fontSize: '0.8rem',
  lineHeight: 1.4,
  fontWeight: 500,
  fontVariantNumeric: 'tabular-nums',
} as const;
